/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import Image from 'next/image'

import FavoriteButton from 'components/Favorites/FavoriteButton'

import style from './FavoriteListingCard.module.scss'

import getListingCloudinaryId from 'utils/strings/getListingCloudinaryId'
import cloudinaryLoader from 'utils/imageLoaders/cloudinaryLoader'

import Exclimation from 'assets/icons/icon-exclamationError.svg'

import type { SimpleFavoriteListing } from 'types/favorites'
import type { Listing } from 'types/Listing.type'

type ResignedListingCardProps = {
  listing: SimpleFavoriteListing
  isFaded: boolean
}

const ResignedListingCard: React.FC<ResignedListingCardProps> = ({
  listing,
  isFaded,
}) => {
  return (
    listing && (
      <div
        className={`${style.card} ${style.resignedCard} ${style.result} ${
          isFaded ? style.faded : ''
        }`}
        id={`favoriteListingCard-${listing.objectID}`}
      >
        <div
          className={`${style.resultImage}`}
          id={`listing_${listing['objectID']}`}
        >
          <div className={`${style.imagesWrapper}`}>
            <div className="image is-16by9-desktop is-3by2-mobile">
              <Image
                alt=""
                fill
                loader={cloudinaryLoader}
                sizes="(max-width: 600px) calc(100vw - 3rem), 320px"
                src={getListingCloudinaryId(listing['ImageUrl'])}
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
          </div>
        </div>
        {!isFaded && (
          <FavoriteButton
            container="favoritesPage"
            listing={listing as unknown as Listing}
          />
        )}
        <div
          className={style.resultDetails}
          id={`listing_${listing['objectID']}`}
        >
          <div className={style.resultDetailsDescription}>
            <span
              className={`${style.resultHeadline} ${style.resignedHeadline}`}
            >
              {listing['Headline']}
            </span>
            <div className={style.warning}>
              <Exclimation className={style.warningExclimation} />
              This property is no longer available.
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default ResignedListingCard
